// extracted by mini-css-extract-plugin
export default {"container":"uxkdZZ","label":"dPev1j","tooltipContainer":"WflazH","nameContainer":"n0KHjr","nameButton":"sCaCpz","name":"c78Rn_","tooltip":"xWwgDX"};